"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteUnavailability2 = exports.useDeleteUnavailability = void 0;
const confirm_1 = __importDefault(require("@app/component/modals/confirm"));
const ui_1 = require("@app/component/ui");
const request_1 = require("@app/request");
const util_1 = require("@app/util");
const use_modal_1 = require("@app/util/modal/use-modal");
const is_loading_1 = __importDefault(require("./is-loading"));
const create_ac_1 = require("./util/create-ac");
const useDeleteUnavailability = () => {
    const { openModal, closeModal } = (0, use_modal_1.useModal)();
    return (0, exports.deleteUnavailability2)(openModal, closeModal);
};
exports.useDeleteUnavailability = useDeleteUnavailability;
const deleteUnavailability2 = (openModal, closeModal) => (0, create_ac_1.createAC)(async (dispatch, { details, isUnavailability, workspaceId, afterSubmit }) => {
    openModal(confirm_1.default, {
        title: (0, util_1.t)('MULTI_ACTION_DEL_CONFIRM_TITLE'),
        type: ui_1.Alert.TYPES.ERROR,
        confirmLabel: (0, util_1.t)('DELETE'),
        repeatingTimeOffs: true,
        // @ts-expect-error idk
        onConfirm: async (props) => {
            if (isUnavailability) {
                await (0, request_1.requestAvailabilityDeleteMulti)({
                    data: [
                        { id: details.id, recurrenceRemoveFollowing: !!props?.recurrence },
                    ],
                    workspace: workspaceId,
                }, null).then((r) => {
                    // dispatch(setModal(null))
                    // close modal
                    closeModal();
                    if (!r.error)
                        util_1.notification.success({ code: 'success', message: '' });
                });
            }
            else {
                await (0, request_1.requestTimeOffDeleteMulti)({
                    data: [
                        { id: details.id, recurrenceRemoveFollowing: !!props?.recurrence },
                    ],
                    workspace: workspaceId,
                }, null).then((r) => {
                    // dispatch(setModal(null))
                    // close modal here
                    closeModal();
                    if (!r.error)
                        util_1.notification.success({ code: 'success', message: '' });
                });
            }
            // if an 'afterSubmit' function was provided, call it here
            if (afterSubmit)
                await afterSubmit();
        },
        onConfirmBonusOptions: details?.recurrence
            ? [
                {
                    label: (0, util_1.t)('DELETE_SELECTED'),
                    onConfirmFnParamsObject: { recurrence: false },
                },
                {
                    label: (0, util_1.t)('DELETE_REPEATING'),
                    onConfirmFnParamsObject: { recurrence: true },
                },
            ]
            : undefined,
        onConfirmBonusOptionsTitle: (0, util_1.t)('REPEATING_TIMEOFFS'),
        cancelLabel: (0, util_1.t)('CANCEL'),
        onCancel: () => { },
        subtitle: (0, util_1.t)('MULTI_ACTION_DEL_CONFIRM_DELETE_SUBTITLE_X', { x: 1 }),
        recordsList: [details],
        buttonColor: 'red',
        overSidebar: true,
    });
    util_1.multiSelectUtil.multiSelectClear();
    await dispatch((0, is_loading_1.default)('create-plan', true));
});
exports.deleteUnavailability2 = deleteUnavailability2;
